/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';

import deleteIcon from '../../../../assets/images/delete.svg';
import './index.scss';

Modal.setAppElement('#root');

class InsuranceListPreview extends React.Component {
  render() {
    const {
      modelopen,
      closeServiceModal,
      list,
      deleteFromPreview,
      addFromPreview
    } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Confirm insurance list</div>
              <button className="modal-close" onClick={closeServiceModal}>
                <i className="material-icons">close</i>
              </button>
              <div className="uploaded-list">
                {list.map((insurance, index) => <div className="uploaded-list_container">
                  <div className="uploaded-list_container_name">{insurance}</div>
                  <div className="uploaded-list_container_delete">
                    <img src={deleteIcon} onClick={() => deleteFromPreview(index)} />
                  </div>
                </div>)}
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={addFromPreview}
                >
                  ADD
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={closeServiceModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InsuranceListPreview;
